import { API_ROUTES } from '../constants/apiRoutes';
import api from '../services/api.service';
import { extractData } from '../utils/helpers/extractDataHelper';

const schema = {
  updateUserProfileRequest: async (params = {}) => {
    try {
      const response = await api.put(API_ROUTES.UPDATE_USER_PROFILE, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  updateProfileSettingsRequest: async (params = {}) => {
    try {
      const response = await api.put(API_ROUTES.UPDATE_PROFILE_SETTINGS, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getOwnLeavesRequest: async () => {
    try {
      const response = await api.get(API_ROUTES.GET_OWN_LEAVES);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
};

export default schema;
